import { render, staticRenderFns } from "./OutputFile.vue?vue&type=template&id=70fac53e"
import script from "./OutputFile.vue?vue&type=script&lang=ts"
export * from "./OutputFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports